module.exports = __webpack_public_path__ + "img/sandbox-dp.f385cb56.svg";